// document.addEventListener("DOMContentLoaded", function() {
//     const labels = document.querySelectorAll('fieldset.js.product-form__input label');

//     labels.forEach(label => {
//         label.addEventListener('change', function() {
//             const productForm = document.querySelector('[bss-b2b-product-form="quickview"]');

//             BSS_B2B?.observer?.productSubject?.notifyObserver?.(
//                 'VariantChange',
//                 'VariantSelectChange',
//                 { productForm }
//             );
//         });
//     });
// });

// if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
//     setTimeout(() => {
//       const observer = new MutationObserver((MutationList) => {
//         for (let item of MutationList) {
//           if (item.target.classList?.contains('cart-recommendations')) {
//             window.dispatchEvent(new Event("scroll"));
//           }
//         }
//       });

//       observer.observe(document.body, {
//         childList: true,
//         subtree: true
//       });
//     }, 300);
//   }

// let counter = 0;
// const interval = setInterval(() => {
//     let element = BSS_B2B.rf.form?.name;
//     if (element) {
//         const h1 = document.querySelector(".bss-b2b-registration-form-title h1");
//         h1.textContent = element;
//         clearInterval(interval);
//     } else {
//         counter += 100;
//         if (counter >= 10000) {
//             clearInterval(interval);
//         }
//     }
// }, 100); 

console.log("ACTION")

document.addEventListener("click", function(e) {
  const cartBtn = e.target.closest(".header__icon--cart");
  console.log("cartBtn: ",cartBtn)
  if (!cartBtn) return;
  setTimeout(() => {
    BSS_B2B.observer.productSubject.notifyObserver('ProductMutate', 'ProductPriceMutate');;
  }, 2000);
});